import Navigation from './modules/Navigation.js';
import MobileNavigation from './modules/MobileNavigation.js';

document.addEventListener('DOMContentLoaded', function() {
  Navigation();
  MobileNavigation();
});

/** import external dependencies */
import 'jquery';

/** Import everything from autoload */
// import './autoload/**/*'

/** import local dependencies */
import Router from './util/Router';
import common from './routes/common';
// import aboutUs from './routes/about';

/** Shared Constructs */
// import faviconBadge from './shared/favicon-badge.js';

/** Theme Constructs */
import alertBar from './theme/alert-bar';
import gallerySlides from './theme/gallery-slides';
import maxWidthIFrame from './theme/max-width-iframe';
// import modal from './theme/modal';
import mobileMenu from './theme/colab-mobile-menu';
import scrollTransition from './theme/scroll-transition';
import selectChangeLocation from './theme/select-change-location';
import testimonialsSlides from './theme/testimonials-slides';
import homeSlides from './theme/home.js'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

document.addEventListener('DOMContentLoaded', function() {

  /** Shared Constructs */
  // faviconBadge();

  /** Theme Constructs */
  alertBar();
  gallerySlides();
  maxWidthIFrame();
  mobileMenu();
  scrollTransition();
  selectChangeLocation();
  testimonialsSlides();
  homeSlides();
  // modal();

  /**
   * Calendly iframe height
   *
   * @todo This does not appear to fire on initial load.
   */
  (function () {
    function isCalendlyEvent(e) {
      return e.data.event &&
             e.data.event.indexOf('calendly') === 0;
    };

    window.addEventListener('message', function(e) {
      // if (isCalendlyEvent(e)) {
      //   console.log(e.data);
      //   console.log(e.target);
      //   console.log(e.target.outerHeight);
      // }

      let contentHeight = e.target.outerHeight;
      // console.log(contentHeight);

      // console.log(e);
      // console.log(e.target);
      // console.log(e.target.getElementsByClassName('booking')[0].outerHeight);

      jQuery('iframe[src*="calendly.com"]').css({
        height: contentHeight,
      });
    }, false);
  })();

});
